import { FlexColumn } from '@gorila-shared-ui/components';
import { FileRow, FileUploader } from 'baseui/file-uploader';
import { ALL_EXTENSIONS } from '../../constants/app';

type Props = {
  files?: FileRow[];
  onFilesChange: (files?: FileRow[]) => void;
  onBlur?: () => void;
};

function MultipleDocumentUploader({ files, onFilesChange, onBlur }: Readonly<Props>) {
  return (
    <FlexColumn>
      <FileUploader
        accept={ALL_EXTENSIONS}
        fileRows={files}
        setFileRows={onFilesChange}
        onBlur={onBlur}
        multiple
        buttonText="Buscar archivo"
        contentMessage="o arrastra un archivo aquí para subir"
        itemPreview
        overrides={{
          FileRowUploadText: {
            props: (props) => {
              if (props?.['aria-invalid']) {
                return { ...props, children: `Sube archivos: ${ALL_EXTENSIONS.join(', ')} para un formato válido` };
              }
              if (props.children === 'Uploading') {
                return {
                  ...props,
                  children: 'Cargando...',
                };
              }
              return { ...props, children: 'Archivo válido' };
            },
          },
        }}
      />
    </FlexColumn>
  );
}

export default MultipleDocumentUploader;
